/** Portal paths for entity links that have no page of their own.
 *
 * The URL contract (docs/substrate-interaction-design.md) gives districts and
 * committees canonical /app URLs. They open the matching Congress portal view.
 */
export function districtPortalPath(districtId: string | undefined): string {
  const match = /^([A-Za-z]{2})[-\s]?(AL|\d{1,2})$/i.exec((districtId ?? "").trim());
  if (!match) return "/congress/members?chamber=House";
  const state = match[1].toUpperCase();
  const district = /^al$/i.test(match[2]) ? 0 : Number(match[2]);
  return `/congress/members?${new URLSearchParams({ state, chamber: "House", district: String(district) })}`;
}

export function committeePortalPath(code: string | undefined): string {
  const valid = code && /^[a-z0-9]{2,12}$/i.test(code);
  return valid ? `/congress/committees?${new URLSearchParams({ code: code.toLowerCase() })}` : "/congress/committees";
}
